<template>
  <!-- 创建极速约单 -->
  <div class="quick-order-create">
    <div class="quick-order-bg"></div>
    <div class="quick-order-inner">
      <div class="page-title">
        <h3>極速約單</h3>
        <p>超多陪玩師在線搶單，快速為您匹配</p>
      </div>
      <!-- v1.14 -->
      <div class="page-body-new">
        <div class="section-left">
          <div class="section-title order-info-box">
            <span>
              我要約單
            </span>
            <el-popover
              class="info-box"
              placement="bottom"
              width="200"
              trigger="hover"
              content="在約單時設定紅包總金額，發出約單後，前15位搶單的陪玩師將會分得“隨機”金額紅包。若搶單人數不足15人，剩餘金額將在約單結束後退回。（目前本功能無佣金）"
            >
              <img
                class="invited-web"
                src="~@/assets/images/invite-question.png"
                alt=""
                slot="reference"
              />
            </el-popover>
          </div>
          <div class="new-coupon" v-if="newerCoupon">
            <span>新人首單限時優惠！</span>
            <div class="coupon-countdown">
              <span v-show="couponDays >= 1">剩餘</span>
              <Countdown
                :endTime="newerCoupon.deadlineTimestamp"
                :type="couponDays >= 1 ? 'dd' : 'hh/mm/ss'"
                :typeMap="timeType"
                @end="couponInvaild"
                @change="couponTimeChange"
              ></Countdown>
            </div>
          </div>
          <div class="card">
            <div
              class="title"
              :class="{
                disabled: !isLegalTime
              }"
            >
              <div class="title-left">
                <fps-avatar
                  class="avatar"
                  v-if="userInfo"
                  :src="useUserInfo ? useUserInfo.avatarUrl : ''"
                  :dressup="userInfo.avatarFrame"
                />
                <span>想找什麼樣的陪玩師？</span>
              </div>
            </div>
            <div class="form" :class="{ disabled: !isLegalTime }">
              <div
                :class="{
                  item: true,
                  skill: true,
                  disabled: !skillLabel
                }"
                @click="skillDialogOpen"
              >
                {{ skillLabel }}
              </div>
              <div class="items">
                <div class="item" @click="changeSex">
                  {{ currentSelectedSex.label }}
                </div>
                <div class="item mobile">
                  <div @click="prizeDialogOpen">
                    <span>{{
                      currentSelectedPrice
                        ? '$' + currentSelectedPrice + '以內'
                        : '單價不限'
                    }}</span>
                  </div>
                </div>
                <el-select
                  :disabled="!isLegalTime"
                  v-model="currentSelectedPrice"
                  value-key="value"
                  class="quickorder-select pc"
                  popper-class="quickorder-select-options"
                >
                  <el-option
                    v-for="price in priceSelectList"
                    :key="price.value"
                    :label="price.label"
                    :value="price.value"
                  >
                    <div class="custom-option">
                      <span>{{ price.label }}</span>
                      <fps-icon class="check-icon" type="check" />
                    </div>
                  </el-option>
                </el-select>
              </div>
              <div class="items">
                <div class="item" :class="{ readonly: !allowChangeUnit }">
                  <div @click="switchUnits">
                    數量<span v-show="currentSelectedSkill.salesUnit"
                      >（{{
                        currentSelectedSkill.salesUnit | salesUnitTranslate
                      }}）</span
                    >
                  </div>
                </div>
                <div class="item readonly count">
                  <InputNumber
                    class="input-number"
                    popper-class="input-number-mini"
                    :disabled="!isLegalTime"
                    :max="newerCoupon ? 1 : 15"
                    v-model="currentSelectedCount"
                  />
                </div>
              </div>
              <div class="item red-beg-input-box">
                <el-input
                  :class="{ 'no-value': redBagText ? false : true }"
                  placeholder="發搶單紅包"
                  v-model="redBagText"
                  @blur="formatCurrency"
                >
                  <span class="" slot="prefix">
                    🧧
                  </span>
                </el-input>
              </div>
              <div class="error" v-if="redBagCount && redBagCount < 10">
                紅包不能小於10幣
              </div>
              <div
                class="item remark"
                v-if="!remarkDisabled"
                @click="remarkDialogOpen"
              >
                <div
                  :class="{
                    text: true,
                    empty: !currentRemarkInForm
                  }"
                >
                  {{ currentRemarkInForm }}
                </div>
              </div>
              <button
                class="submit btn-custom"
                :class="{
                  'btn-player': isPlayer,
                  disabled: submitDisabled
                }"
                @click="myOrderSubmit"
              >
                <i v-if="isLoading1" class="el-icon-loading" />
                <span v-else-if="!isLegalTime">
                  約單開放時間 {{ quickOrderLegalTimes.times }}
                </span>
                <template v-else>
                  <span>
                    我要約單
                  </span>
                  <!-- 暫時應藏 -->
                  <!-- <div v-if="couponTxt" class="coupon">
                    <div class="coupon-inner">
                      {{ couponTxt }}
                    </div>
                  </div> -->
                </template>
              </button>
            </div>
            <div v-if="isMobile" class="mobile-card">
              <div class="text">
                <fps-icon type="lock" :size="40" />
                <p>打開app，即可解鎖極速約單，與更多優質陪玩師匹配呦！</p>
              </div>
              <button @click="downloadApp">打開 app</button>
            </div>
          </div>
        </div>
        <div class="section-right">
          <div class="ongoing" v-show="listProcessing.length">
            <div class="section-title">進行中的約單</div>
            <div
              :class="['card', index == 0 ? 'first' : '']"
              v-for="(orderInfo, index) in listProcessing"
              :key="`${orderInfo.uuid}_${orderInfo.gameId}`"
              @click="viewOrder(orderInfo)"
            >
              <div class="title">
                <div class="title-left">
                  <fps-avatar
                    class="avatar"
                    :src="orderInfo.userAvatarUrl"
                    :dressup="orderInfo.avatarFrame"
                  />
                  <div
                    class="userlevel-tag"
                    :class="`level-${orderInfo.userLevel}`"
                  ></div>
                  <!-- <div class="avatar">
                    <img :src="orderInfo.userAvatarUrl + '?d=300x300'" :alt="orderInfo.userNickname" />
                  </div> -->
                  <span>正在尋找陪玩師</span>
                  <span
                    class="promise-win"
                    v-if="orderInfo.type === 'PromiseWin'"
                    >排位保贏
                  </span>
                </div>
                <div>
                  <UserRelation
                    v-if="userInfo.uuid !== orderInfo.userUuid"
                    height="30px"
                    :currentMasterId="orderInfo.userUuid || ''"
                    @click.native.stop
                    :defaultReason="[
                      '發布違規約單內容',
                      '惡意刷單',
                      '其他違規行為'
                    ]"
                    :hasBlock="false"
                  ></UserRelation>
                </div>
              </div>
              <div
                :class="{
                  'order-body': true
                }"
              >
                <!-- 'allow-order': allowOrder(orderInfo) -->
                <img
                  class="game-logo"
                  :src="orderInfo.gameLogo"
                  :alt="orderInfo.gameName"
                />
                <div class="main-info">
                  <h3>
                    <span class="main-name">
                      <template v-if="orderInfo.hbAmount">🧧</template>
                      {{ orderInfo.gameName }}</span
                    >
                    <span class="order-price">{{
                      orderInfo | orderInfoTranslate(['budgetAmountRight'])
                    }}</span>
                  </h3>
                  <p class="order-desc">
                    {{
                      orderInfo
                        | orderInfoTranslate([
                          'gameModelName',
                          'gameQuickMatchLevels',
                          'sex'
                        ])
                    }}
                  </p>
                  <p
                    class="order-desc remark"
                    v-if="translateRemark(orderInfo)"
                  >
                    備註：{{ translateRemark(orderInfo) }}
                  </p>
                </div>
              </div>
              <div
                v-if="
                  allowOrder &&
                    orderInfo.canGrabOrder &&
                    !hasGrabOrder(orderInfo.grabItemVoList)
                "
                class="buttons"
              >
                <button
                  class="btn-custom"
                  @click.stop="checkOrderStatus(orderInfo, 'orderByAuto')"
                  :class="{ disabled: orderInfo.orderByAutoLoading }"
                  v-if="allowAuto(orderInfo.gameId)"
                >
                  一鍵搶單
                </button>
                <button
                  class="btn-custom default"
                  v-if="!orderInfo.onlyVoice"
                  :class="{ disabled: orderInfo.orderByTextShowLoading }"
                  @click.stop="checkOrderStatus(orderInfo, 'orderByTextShow')"
                >
                  文字搶單
                </button>
                <button
                  class="btn-custom default"
                  :class="{ disabled: orderInfo.orderByAudioShowLoading }"
                  @click.stop="checkOrderStatus(orderInfo, 'orderByAudioShow')"
                >
                  {{ orderInfo.onlyVoice ? '僅限語音搶單' : '語音搶單' }}
                </button>
              </div>
              <div class="order-footer">
                <div>
                  <template v-if="orderInfo.grabItemVoList">
                    <template v-if="hasGrabOrder(orderInfo.grabItemVoList)"
                      >已搶單</template
                    >
                    <template v-else
                      >{{
                        orderInfo.grabItemVoList.length
                      }}位陪玩師在搶單</template
                    >
                  </template>
                </div>
                <div>
                  <quick-count-down
                    :total="15"
                    prefix="倒計時"
                    color="#323D4F"
                    :timestamp="orderInfo.createTime"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="complete">
            <div class="section-title">已完成的約單</div>
            <div
              :class="['card', index == 0 ? 'first' : '']"
              v-for="(orderInfo, index) in listFinished"
              :key="`${orderInfo.uuid}_${orderInfo.gameId}`"
            >
              <div class="title">
                <div class="infos">
                  <fps-avatar
                    class="avatar"
                    :src="orderInfo.userAvatarUrl"
                    :dressup="orderInfo.avatarFrame"
                  />
                  <fps-avatar
                    class="avatar"
                    :src="orderInfo.matchedPlayerUrl"
                    :dressup="orderInfo.playerFrame"
                  />
                  完成約單
                  <span
                    style="display:inline-block;margin-left:2px"
                    v-if="orderInfo.quickMatchRandom"
                    >🎲</span
                  >
                </div>
                <div class="time">
                  {{ orderInfo.updateTime | translateDateTime }}
                </div>
              </div>
              <div class="order-body">
                <template v-if="orderInfo.hbAmount">🧧</template>
                {{ orderInfo | orderInfoTranslate }}
              </div>
            </div>
            <div v-if="finishedBottomVisible" class="bottom">
              僅保留最近10條約單紀錄
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择价格-h5 -->
    <el-dialog
      append-to-body
      width="375px"
      :visible.sync="selectPriceVisible"
      :show-close="false"
      custom-class="dialog-quick-order"
    >
      <div class="dialog-prize">
        <div class="title">
          <button @click="prizeDialogClose">取消</button>
          <p>選擇單價</p>
          <button class="confirm" @click="prizeDialogSubmit">確認</button>
        </div>
        <div class="scroller">
          <mt-picker
            :slots="[
              {
                values: priceSelectList
              }
            ]"
            value-key="label"
            :item-height="50"
            @change="changePricePickerValue"
          />
        </div>
      </div>
    </el-dialog>

    <!-- 选择技能（游戏） -->
    <el-dialog
      append-to-body
      width="375px"
      :visible.sync="selectSkillVisible"
      :show-close="false"
      custom-class="dialog-quick-order"
    >
      <div class="dialog-skill-wrap">
        <div class="dialog-skill-inner">
          <quick-order-skill
            ref="skills"
            :isOpen="selectSkillVisible"
            :initSkillList="skillList"
            :initSkill="currentSelectedSkill"
            :initMode="currentSelectedMode"
            :initLevel="currentSelectedLevel"
          />
        </div>
        <div class="button-wrap">
          <button class="submit btn-custom" @click="skillDialogSubmit">
            確定
          </button>
        </div>
      </div>
    </el-dialog>

    <!-- 选择/填写备注 -->
    <el-dialog
      append-to-body
      width="385px"
      :visible.sync="selectRemarkVisible"
      :show-close="false"
      custom-class="dialog-quick-order"
    >
      <quick-order-remark
        ref="remark"
        :isOpen="selectRemarkVisible"
        :tagList="currentSelectedSkill.recommendRemarkList"
        :initTags="currentSelectedReamark"
        :initRadio="currentOnlyVoice"
        :initPrivately="currentPrivately"
        :initAutoApply="currentAutoApply"
      >
      </quick-order-remark>
      <div class="button-wrap">
        <button class="submit btn-custom" @click="remarkDialogSubmit">
          確定
        </button>
      </div>
    </el-dialog>

    <!-- 文字抢单 -->
    <el-dialog
      append-to-body
      width="375px"
      :visible.sync="orderByTextShow"
      :show-close="false"
      custom-class="dialog-quick-order"
    >
      <div class="order-text-wrap">
        <div class="title">
          <span>豐富的介紹更容易搶到單喔</span>
          <div class="close" @click="orderByTextShow = false">
            <fps-icon type="close" size="20" color="#666" />
          </div>
        </div>
        <div class="desc">
          例如：哈嘍我人皮話多，最擅長的角色是珍娜，可以當你專屬sup (5~25個字)
        </div>
        <div class="textarea">
          <textarea v-model="orderByTextContent" :rows="3"> </textarea>
          <div class="letter-num">
            <span :class="orderByTextContent.length > 40 ? 'light' : ''">{{
              orderByTextContent.length
            }}</span
            >/{{ 40 }}
          </div>
          <div v-show="isLoading2" class="gap"></div>
        </div>
        <div class="tip">提示：嚴禁約色，違規者嚴重懲罰</div>
      </div>
      <div class="button-wrap">
        <button
          class="submit btn-custom"
          :class="{
            disabled:
              !orderByTextContent ||
              isLoading2 ||
              orderByTextContent.length > 40 ||
              illegalContent
          }"
          @click="grabOrderHandler()"
        >
          <i v-if="isLoading2" class="el-icon-loading" />
          <template v-else>確定搶單</template>
        </button>
      </div>
    </el-dialog>

    <!-- 語音抢单 -->
    <el-dialog
      append-to-body
      width="375px"
      :visible.sync="orderByAudioShow"
      custom-class="dialog-quick-order"
      @close="audioDelete"
    >
      <div class="order-audio-wrap">
        <div class="close" @click="orderByAudioShow = false">
          <fps-icon type="close" size="20" color="#666" />
        </div>
        <div class="title">錄製語音搶單</div>
        <div class="desc">
          <p>點擊開始錄音</p>
          <p>時長3～15秒</p>
        </div>
        <div class="audio-panel">
          <div class="time">{{ audioSeconds }}″</div>
          <div class="circle">
            <el-progress
              type="circle"
              :show-text="false"
              :percentage="audioPercent"
              :width="88"
              :stroke-width="8"
              color="#FD8ABD"
            />
            <div class="button" @click="audioClick">
              <i
                v-show="audioLoading"
                class="el-icon-loading"
                style="color: #fff"
              />
              <fps-icon
                v-show="!audioLoading"
                :type="audioIcon"
                color="#fff"
                size="32"
              />
            </div>
          </div>
          <div class="delete">
            <div @click="audioDelete">
              <fps-icon
                v-show="audioStatus > 1"
                type="delete"
                color="#999"
                size="24"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button
          class="submit btn-custom"
          :class="{ disabled: isLoading2 || !audioFile }"
          @click="grabOrderHandler()"
        >
          <i v-if="isLoading2" class="el-icon-loading" />
          <template v-else>確定搶單</template>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { uploadFileToS3 } from '@/api';
import QuickOrderSkill from './quick-order-skill';
import QuickOrderRemark from './quick-order-remark';
import { orderInfoTranslate } from '@/filters/index';
import InputNumber from './input-number';
import QuickCountDown from './count-down';
import Recorder from 'js-audio-recorder';
import { salesUnitTranslate } from '@/filters';
import UserRelation from '@/components/UserRelation';
import Countdown from '@/components/common/countdown';

const SEX_LIST = [
  {
    index: 0,
    label: '性別不限',
    value: 'NobodyKnow'
  },
  {
    index: 1,
    label: '女生',
    value: 'Female'
  },
  {
    index: 2,
    label: '男生',
    value: 'Male'
  }
];

export default {
  name: 'QuickOrderCreate',
  components: {
    InputNumber,
    QuickOrderSkill,
    QuickOrderRemark,
    QuickCountDown,
    UserRelation,
    Countdown
  },
  filters: {
    translateSex(sex) {
      if (sex === 'Male') return '男生';
      if (sex === 'Female') return '女生';
      return '不限';
    },
    translateDateTime(val) {
      if (!val) return;
      const d = new Date(val);
      const nowDate = new Date();
      let prefix = '';
      const day = d.getDate();
      const month = d.getMonth() + 1;
      if (day === nowDate.getDate()) {
        prefix = '今天';
      } else {
        prefix = `${month}月${day}日`;
      }
      return `${prefix} ${d.$format('hh:mm')}`;
    }
  },
  data() {
    const isProd = process.env.VUE_APP_ENV === 'production';
    const promiseWinFiter = [
      {
        skill: 1,
        mode: isProd ? [29, 30] : [31, 32]
      },
      {
        skill: 6,
        mode: isProd ? [31] : [33]
      }
    ];
    return {
      allowRefresh: true, // 是否允許輪詢刷新列表
      isMobile: window.innerWidth < 600,
      isLoading1: false,
      isLoading2: false,
      sexList: SEX_LIST,
      skillList: [],
      currentSelectedSkill: {},
      currentSelectedMode: {},
      currentSelectedSex: SEX_LIST[0],
      currentSelectedCount: 1,
      currentSelectedReamark: [],
      currentOnlyVoice: false,
      currentPrivately: false,
      currentAutoApply: false,
      currentSelectedPrice: '',
      currentInputRemark: '',
      currentSelectTime: new Date().$format('hh:mm'),
      currentSelectedLevel: [],
      drawerSelectedSkill: {},
      drawerSelectedPrice: {},
      timer: null,
      currentRemarkReason: '',
      couponTxt: '',
      selectPriceVisible: false,
      selectSkillVisible: false,
      selectRemarkVisible: false,
      listProcessing: [],
      listFinished: [],
      finishedBottomVisible: false,
      lastInfo: {},
      quickOrderType: 'Normal', // 约单类型
      sexDisabled: false, // 性别不可选
      remarkDisabled: false, // 备注不可选

      // 抢单
      orderUuid: '',
      reducePrice: false, // 是否愿意降价抢单
      orderByTextShow: false,
      orderByTextContent: '',
      orderByAudioShow: false,
      audioLoading: false,
      audioStatus: 0, // 0: 待录制； 1: 录制中； 2: 录制结束（待播放）； 3: 播放中； 4: 暫停中
      audioSeconds: 0,
      audioPlayed: -1,
      recorder: null,
      interval: null,
      audioFile: null,
      promiseWinFiter,
      couponDays: 1, // 優惠券剩餘天數大於1時只展示天數
      timeType: {
        dd: {
          unit: '天',
          val: 86400000,
          extral: ''
        },
        hh: {
          unit: ':',
          val: 3600000,
          extral: '0'
        },
        mm: {
          unit: ':',
          val: 60000,
          extral: '0'
        },
        ss: {
          unit: '',
          val: 1000,
          extral: '0'
        }
      },
      redBagText: '',
      redBagCount: '',
      redBagInfoVisible: false
    };
  },
  props: {
    onlyVoiceText: String
  },
  watch: {
    orderByTextShow(nVal) {
      this.allowRefresh = !nVal;
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'masterInfo',
      'quickOrderLegalTimes',
      'newerCoupon'
    ]),
    useUserInfo() {
      return this.userInfo || {};
    },
    isPlayer() {
      return this.userInfo ? this.userInfo.userKind === 'Player' : '';
    },
    // 約單開放時間 20:00~凌晨01:00
    isLegalTime() {
      return this.quickOrderLegalTimes.isOpen;
    },
    // 允许切换技能单位: 英雄聯盟，峽谷激鬥
    allowChangeUnit() {
      if (!this.currentSelectedSkill.id) return false;
      return this.currentSelectedSkill.id === 1;
    },
    // 小鬧鍾
    isClock() {
      return this.currentSelectedSkill.id == 38;
    },
    skillLabel() {
      const skill = this.currentSelectedSkill;
      if (!skill) return '';
      let str = skill.name || '';
      if (!str) return '';
      if (this.isClock) {
        str += ` ${this.currentSelectTime}`;
        return str;
      }
      let mode = this.currentSelectedMode.name;
      if (mode) {
        if (mode === '不限') {
          mode = '模式不限';
        }
        str += `  ${mode}`;
      }
      const rankList = this.currentSelectedSkill.quickMatchLevel || [];
      const ranks = this.currentSelectedLevel;
      let rank = rankList.filter(item => ranks.includes(item)).join('/');
      if (rank) {
        if (rank === '不限') {
          rank = '牌位不限';
        }
        str += `  ${rank}`;
      }
      return str;
    },
    priceSelectList() {
      let list = this.currentSelectedSkill.quickMatchPriceGears || [];
      if (this.quickOrderType === 'PromiseWin') {
        list = this.currentSelectedSkill.promiseWinPriceGears || [];
      }
      return list.map(value => {
        return value === '999999'
          ? {
              value: '',
              label: '單價不限'
            }
          : {
              value,
              label: `$${value}以內`
            };
      });
    },
    currentRemarkInForm() {
      const str1 = this.currentOnlyVoice ? '#' + this.onlyVoiceText : '';
      let str2 = this.currentSelectedReamark.join('#');
      if (str2) {
        str2 = '#' + str2;
      }
      let reason = this.currentRemarkReason ? this.currentRemarkReason : '';
      return `${reason}${str1}${str2}`;
    },
    translateRemark() {
      const text = this.onlyVoiceText;
      return function(orderInfo) {
        const { onlyVoice, remark = '', remarkReason = '' } = orderInfo;
        let voice = onlyVoice ? '#' + text : '';
        if (!voice && !remark && !remarkReason) {
          return '';
        }
        let str = remark ? '#' + remark.replace(/\//g, '#') : '';
        return `${remarkReason || ''}${voice}${str}`;
      };
    },
    audioIcon() {
      return ['recording', 'time-out', 'play', 'stop', 'play'][
        this.audioStatus
      ];
    },
    audioPercent() {
      if (this.audioPlayed > -1) {
        return (this.audioPlayed / this.audioSeconds) * 100;
      } else if (this.audioSeconds > 15) {
        return 100;
      } else {
        return (this.audioSeconds / 15) * 100;
      }
    },
    illegalContent() {
      const text = this.orderByTextContent;
      if (text.length < 5) {
        // 總共限制最少5字
        return true;
      }
      const reg = new RegExp('[\u4e00-\u9fa5]+');
      const ary = text.split('').filter(str => {
        return reg.test(str);
      });
      // 中文限制最少5字
      return ary.length < 5;
    },
    submitDisabled() {
      if (this.skillLabel) {
        if (this.redBagCount) {
          return this.redBagCount < 10 ? 'disabled' : false;
        } else {
          return false;
        }
      } else {
        return 'disabled';
      }
    }
  },
  created() {
    this.getInitData();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.timer = null;
  },
  methods: {
    ...mapActions('app', ['getQuickOrderSkills']),
    // 允許一鍵約單
    allowAuto(gameId) {
      //传说对决 小鬧鐘
      return ![6, 38].includes(gameId);
    },
    couponInvaild() {
      this.$store.dispatch('app/getUserAccount');
    },
    couponTimeChange(times, stringType) {
      if (/dd/.test(stringType) && times[0]) {
        this.couponDays = times[0];
      } else {
        this.couponDays = 0;
      }
    },
    async getInitData() {
      this.$emit('setIdentify', true);
      this.skillList = (await this.getQuickOrderSkills()) || [];
      this.setSelectedSkill(this.skillList[0]);
      this.getLastChoose().then(() => {
        let initSkillId = sessionStorage.getItem(
          'initSkillId4QuickOrderCreate'
        );
        if (initSkillId) {
          sessionStorage.removeItem('initSkillId4QuickOrderCreate');
          initSkillId = +initSkillId;
          if (initSkillId !== this.lastInfo.gameId) {
            // 傳入了初始技能，但跟從服務端獲取的上次技能不一樣，則以傳入為準
            const skillItem = this.skillList.find(
              skill => skill.id === initSkillId
            );
            if (skillItem) {
              this.setSelectedSkill(skillItem);
              // this.currentSelectedSkill = skillItem
              return;
            }
          }
        }
        this.skillList.some(skill => {
          if (skill.id && skill.id === this.lastInfo.gameId) {
            this.currentSelectedSkill = skill;
            if (!skill.gameModelList) {
              this.currentSelectedMode = {};
              skill.gameModelList = [];
            }
            skill.gameModelList.some(mode => {
              if (mode.id === this.lastInfo.gameModelId) {
                this.currentSelectedMode = mode;
                return true;
              }
            });

            if (this.lastInfo.gameQuickMatchLevels) {
              this.currentSelectedLevel = this.lastInfo.gameQuickMatchLevels.split(
                '/'
              );
            }
            this.priceSelectList.some(item => {
              if ((item.value | 0) === this.lastInfo.budgetAmountRight) {
                this.currentSelectedPrice = item.value;
              }
            });
            this.currentSelectedReamark = !this.lastInfo.remark
              ? []
              : this.lastInfo.remark.split('/');
            this.currentOnlyVoice = this.lastInfo.onlyVoice;
            if (this.lastInfo.salesUnit) {
              this.currentSelectedSkill.salesUnit = this.allowChangeUnit
                ? this.lastInfo.salesUnit
                : skill.salesUnit;
            }
            this.currentSelectedCount = this.lastInfo.count || 1;
            SEX_LIST.some(sex => {
              if (sex.value === this.lastInfo.sex) {
                this.currentSelectedSex = sex;
                return true;
              }
            });
            if (this.lastInfo.type === 'PromiseWin') {
              this.initPromiseWin();
            }
            return true;
          }
        });
      });

      // 进行中约单
      const loopRequest = () => {
        // 获取进行中的约单
        if (this.$route.name !== 'QuickOrder') return;
        this.$http
          .get('/match/quick/list', {
            status: 'Processing'
          })
          .then(({ data }) => {
            if (data) {
              if (this.allowRefresh) {
                this.listProcessing = data.pageContent.filter(item => {
                  if (
                    item.matchStatus === 'Processing' &&
                    this.userInfo.uuid === item.userUuid
                  ) {
                    this.viewOrder(item);
                  }
                  return item.matchStatus === 'Processing';
                }) || [];
                this.listProcessing = this.listProcessing.filter(item=>{
                  return item && ((item.privately && this.allowOrder && item.canGrabOrder && !this.hasGrabOrder(item.grabItemVoList)) || !item.privately)
                })
              }
              if (!this.isMobile) {
                this.timer = setTimeout(loopRequest, 5000);
              }
            } else {
              this.$emit('error');
            }
          })
          .catch(err => {
            this.$emit('error', err);
          });
      };

      loopRequest();

      // 已完成约单
      this.$http
        .get('/match/quick/list', {
          status: 'Finished'
        })
        .then(({ data }) => {
          if (data) {
            this.listFinished = data.pageContent.filter(
              item => item.matchStatus === 'Finished'
            );
            if (this.listFinished.length > 9) {
              this.finishedBottomVisible = true;
            }
          } else {
            this.$emit('error');
          }
        })
        .catch(err => {
          this.$emit('error', err);
        });

      // 获取按钮上气泡信息
      // this.$http.get('/match/quick/credit/display/content').then(({ data }) => {
      //   if (data) {
      //     const { isDisplay, content } = data;
      //     this.couponTxt = isDisplay ? content : '';
      //   }
      // });
    },
    // 设置初始表单信息
    setSelectedSkill(skill) {
      if (!skill) return;
      this.currentSelectedSkill = skill;
      this.currentSelectedSkill.salesUnit = skill.salesUnit;
      if (skill.gameModelList) {
        this.currentSelectedMode = skill.gameModelList[0];
      } else {
        this.currentSelectedMode = {};
      }
      if (
        skill.id === 1 &&
        skill.quickMatchLevel &&
        skill.quickMatchLevel.length
      ) {
        this.currentSelectedLevel = ['不限'];
      } else {
        this.currentSelectedLevel = [];
      }
      this.currentSelectedPrice = this.priceSelectList[0].value;
      this.currentSelectedReamark = [];
      this.currentOnlyVoice = false;
      this.currentPrivately = false;
      this.currentAutoApply = false;
    },

    // 技能相关操作
    skillDialogOpen() {
      if (!this.isLegalTime || !this.skillLabel) return;
      this.selectSkillVisible = true;
    },
    /**
     * @description: 牌位是否必选
     */
    levelRequired() {
      const tar = this.$refs['skills'];
      if (!tar) return;
      const skill = tar.selectedSkill;
      const mode = tar.selectedMode;
      const level = tar.selectedLevel;
      const isRequiredSkill = this.promiseWinFiter.some(item => {
        return skill.id === item.skill && item.mode.includes(mode.id);
      });
      const noChoose = !level.length || level[0] === '不限';
      // 是必选技能和模式且没有选牌位
      if (isRequiredSkill && noChoose) {
        return this.$message.error({
          message: '請選擇您的牌位'
        });
      }
    },
    // 保赢模式
    isPromiseWin() {
      const tar = this.$refs['skills'];
      if (!tar) return;
      const skill = tar.selectedSkill;
      const mode = tar.selectedMode;
      const isWinMode = this.promiseWinFiter.some(item => {
        return skill.id === item.skill && item.mode.includes(mode.id);
      });
      if (!isWinMode) return 'notWin';
      let message = {
        1: '菁英',
        6: '永恆傳說'
      };
      return this.$confirm({
        content: `1. “保赢”約單將推送給全平台“${
          message[skill.id]
        }”陪玩师<br>2. 价格按勝場計價，具体價格與段位相关，请与陪玩師商定<br>3. 陪玩師性別暂不支持选择`,
        title: '“保贏”單說明',
        confirmButtonText: '同意',
        cancelButtonText: '再想想',
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          return 'isWin';
        })
        .catch(() => {
          return false;
        });
    },
    initPromiseWin() {
      this.sexDisabled = true;
      this.currentSelectedSex = SEX_LIST[0];
      this.remarkDisabled = true;
      this.quickOrderType = 'PromiseWin';
      // this.currentSelectedSkill.salesUnit = 'win';
    },
    async skillDialogSubmit() {
      const tar = this.$refs['skills'];
      if (!tar) return;
      const skill = tar.selectedSkill;
      const mode = tar.selectedMode;
      const level = tar.selectedLevel;
      const time = tar.clockTime;
      if (this.levelRequired()) return;
      let allowedWin = await this.isPromiseWin();
      // 如果是保赢单且不同意推送规则
      if (!allowedWin) return;
      const prize = this.currentSelectedPrice;
      this.$nextTick(() => {
        if (!this.priceSelectList.some(item => item.value === prize)) {
          this.currentSelectedPrice = this.priceSelectList[0].value;
        }
      });
      this.currentSelectedSkill = skill;
      if (!tar.modeList.length) {
        this.currentSelectedMode = {};
      } else {
        this.currentSelectedMode = mode;
      }
      if (!tar.levelList.length) {
        this.currentSelectedLevel = [];
      } else {
        this.currentSelectedLevel = level;
      }
      this.currentSelectedReamark = [];
      this.currentRemarkReason = '';
      this.currentOnlyVoice = false;
      this.currentPrivately = false;
      this.currentAutoApply = false;
      this.selectSkillVisible = false;
      this.currentSelectTime = time;

      this.sexDisabled = false;
      this.remarkDisabled = false;
      this.currentSelectedSkill.salesUnit = skill.salesUnit;
      this.quickOrderType = 'Normal';
      if (allowedWin === 'isWin') {
        this.initPromiseWin();
      }
    },

    // 切换性别
    changeSex() {
      if (!this.isLegalTime || this.sexDisabled) return;
      const curr = this.currentSelectedSex;
      const index = curr.index + 1 > SEX_LIST.length - 1 ? 0 : curr.index + 1;
      this.currentSelectedSex = SEX_LIST[index];
    },

    // 价格相关操作
    prizeDialogOpen() {
      if (!this.isLegalTime) return;
      this.selectPriceVisible = true;
    },
    prizeDialogClose() {
      this.selectPriceVisible = false;
    },
    prizeDialogSubmit() {
      this.currentSelectedPrice = this.drawerSelectedPrice.value;
      this.selectPriceVisible = false;
    },
    changePricePickerValue(ref, [val]) {
      this.drawerSelectedPrice = val;
    },

    // 备注相关操作
    remarkDialogOpen() {
      if (!this.isLegalTime) return;
      this.selectRemarkVisible = true;
    },
    remarkDialogSubmit() {
      const tar = this.$refs['remark'];
      if (!tar) return;
      this.currentSelectedReamark = this.currentSelectedSkill.recommendRemarkList.filter(
        tag => tar.selectedTags.includes(tag)
      );
      this.currentOnlyVoice = tar.radioSelected;
      this.currentPrivately = tar.privately;
      this.currentAutoApply = tar.autoApply;
      this.selectRemarkVisible = false;
      this.currentRemarkReason = tar.tips;
    },

    // 提交我的约单
    myOrderSubmit() {
      if (!this.userInfo) {
        this.$util.Login().then(() => {
          location.reload();
        });
        return;
      }
      if (this.isLoading1 || !this.isLegalTime || !this.skillLabel) return;
      if (!this.currentSelectedCount) {
        this.$message.error('請選擇約單數量');
        return;
      }
      this.isLoading1 = true;
      // 創建匹配單之前，校驗時間，數量
      this.$http
        .get('/match/quick/create/checkout')
        .then(() => {
          this.isLoading1 = false;
          this.validateOrderInfo();
        })
        .catch(err => {
          this.$emit('error', err);
        });
    },
    validateOrderInfo() {
      const {
        skillLabel,
        currentSelectedSex,
        currentSelectedPrice,
        currentSelectedSkill,
        currentSelectedCount,
        currentSelectedReamark,
        currentOnlyVoice,
        currentAutoApply,
        currentPrivately,
        currentInputRemark,
        currentSelectedMode,
        currentSelectedLevel,
        currentRemarkInForm,
        currentSelectTime
      } = this;
      const budgetAmountRight = currentSelectedPrice || 999999;
      let content = `${skillLabel.split('  ').join('，')}，${
        currentSelectedSex.label
      }，${orderInfoTranslate(
        {
          budgetAmountRight,
          salesUnit: currentSelectedSkill.salesUnit,
          count: currentSelectedCount
        },
        ['budgetAmountRight']
      )}`;
      if (currentRemarkInForm) {
        content += `，“${currentRemarkInForm}”`;
      }
      let notice =
        '<p style="color:#FA006E;margin-bottom: 14px">選人時間為15分鐘，超時取消可能會扣取$5~$10補償陪玩師喔</p>';

      this.$confirm({
        content: notice + content,
        title: '請確認您的約單要求',
        dangerouslyUseHTMLString: true,
        confirmButtonText: '確認約單',
        cancelButtonText: '取消'
      })
        .then(() => {
          'test';
          console.log();
          this.isLoading1 = true;
          const params = {
            budgetAmountRight,
            count: currentSelectedCount,
            gameId: currentSelectedSkill.id,
            sex: currentSelectedSex.value,
            salesUnit: currentSelectedSkill.salesUnit,
            onlyVoice: currentOnlyVoice,
            privately: currentPrivately,
            autoApply: currentAutoApply,
            type: this.quickOrderType,
            remarkReason: this.currentRemarkReason
          };
          const modelList = currentSelectedSkill.gameModelList;
          if (modelList && modelList.length && currentSelectedMode.id) {
            params.gameModelId = currentSelectedMode.id;
          }
          if (currentInputRemark || currentSelectedReamark.length) {
            const labels = currentSelectedReamark.length
              ? currentSelectedReamark.join('/')
              : '';
            params.remark =
              labels +
              (labels && currentInputRemark ? '/' : '') +
              currentInputRemark;
          }
          if (currentSelectedLevel.length) {
            params.quickMatchLevelList = currentSelectedLevel;
          }
          if (this.isClock) {
            params.extraInfo = JSON.stringify({
              currentSelectTime
            });
          }
          if (this.redBagCount) {
            params.hbAmount = this.redBagCount;
          }
          this.$http
            .post('/match/quick/create', params)
            .then(({ data }) => {
              this.isLoading1 = false;
              this.$emit('create', data, true);
            })
            .catch(err => {
              this.$emit('error', err);
            });
        })
        .catch(err => {
          console.log(err);
          this.isLoading1 = false;
        });
    },

    // 跳转订单（围观）
    viewOrder(orderInfo) {
      this.$emit('setIdentify', false);
      this.$emit('create', orderInfo);
    },
    // 判断当前用户是否允许抢单
    allowOrder(orderInfo) {
      return (
        this.isPlayer &&
        orderInfo.matchStatus === 'Processing' &&
        orderInfo.userUuid !== this.useUserInfo.uuid
      );
    },
    hasGrabOrder(list) {
      return (
        list && list.filter(item => item.userUuid === this.userInfo.uuid).length
      );
    },
    /**
     * @description: 获取上次约单成功的信息
     */
    getLastChoose() {
      return this.$http
        .get('/match/quick/getLastQuickMatch')
        .then(({ data }) => {
          if (!data) return;
          if (data) this.lastInfo = data || {};
          if (data.count === 1) {
            this.lastInfo.count = '';
          }
        });
    },

    /**
     * @description: 包赢单确认
     */
    promiseWinDialog() {
      return this.$confirm({
        content:
          '1. 陪玩師需要自備對應段位可接單遊戲帳號<br/>2. 保贏訂單按勝場計價，價格可根據段位訂製，搶單時請報價<br/>3. 陪玩師點擊同意代表會與用戶達成共識，獲得相互協商的淨勝場次',
        title: '“保贏”單說明',
        dangerouslyUseHTMLString: true,
        confirmButtonText: '同意',
        cancelButtonText: '再想想'
      })
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },

    getMySkillList() {
      return new Promise(resolve => {
        this.$http
          .post('/master/skill', { playerUserUuid: this.userInfo.uuid })
          .then(({ data }) => {
            resolve(data);
          });
      });
    },

    /**
     * @description: 搶單前的前端檢查，對比我的技能設置
     */
    async skillSettingCheck(orderInfo) {
      const skillList = await this.getMySkillList();
      const skillItem = skillList.find(
        item => item.gameId === orderInfo.gameId
      );
      if (!skillItem) return '發生了一些錯誤，請刷新頁面重試';
      let mySettingPrice = skillItem.salesPrice; // 我的設置價格
      const {
        gameId,
        salesUnit,
        gameModelId,
        gameModelName,
        budgetAmountRight,
        gameQuickMatchLevels
      } = orderInfo;
      if ([1, 125].includes(gameId)) {
        if (gameId === 1 && gameQuickMatchLevels) {
          // 段位匹配
          const lowLev = gameQuickMatchLevels.split('/')[0];
          const myLev = skillItem.gameLevelString;
          if (lowLev && myLev) {
            const myLevIndex = [
              '實況主',
              '未打積分',
              '金牌',
              '白金',
              '鑽石',
              '大師',
              '宗師',
              '菁英'
            ].indexOf(myLev);
            let levThrough = true;
            if (['青銅', '白銀', '黃金'].includes(lowLev)) {
              // 金牌及以上
              levThrough = myLevIndex >= 2;
            } else if (['白金', '鑽石'].includes(lowLev)) {
              // 白金及以上
              levThrough = myLevIndex >= 3;
            } else if (lowLev === '大師及以上') {
              // 鑽石及以上
              levThrough = myLevIndex >= 4;
            }
            if (!levThrough) {
              return '您的英雄聯盟認證等級不符合要求，請提升等級後再搶單';
            }
          }
        }
        const priceList = skillItem.skillPriceList || [];
        if (salesUnit === 'Game') {
          // lol && 單位為「局」&& 非保贏單: 是否需要設置對應的模式價格
          if (!/保赢|不限/.test(gameModelName)) {
            const sameUnitItem = priceList.find(
              item => item.gameModelId === gameModelId
            );
            if (sameUnitItem && sameUnitItem.salesUnit === 'Game') {
              mySettingPrice = sameUnitItem.price;
            } else {
              return {
                skillId: skillItem.id,
                gameModelId,
                name: gameModelName,
                title: '搶單模式不符合要求',
                description: `當前未設置“${gameModelName}”模式的金額，請設置後再來搶單`,
                confirmButtonText: '去設置'
              };
            }
          }
        } else if (salesUnit === 'Hour') {
          // lol && 單位為「小時」: 是否需要設置小時的技能單位
          const hourItem = priceList.find(item => item.salesUnit === salesUnit);
          if (hourItem) {
            mySettingPrice = hourItem.price;
          } else {
            return {
              skillId: skillItem.id,
              gameModelId,
              name: '不限模式',
              title: '搶單計價單位不符合要求',
              description: `當前未設置“${salesUnitTranslate(
                salesUnit
              )}”計價單位的金額，請設置後再來搶單`,
              confirmButtonText: '去設置'
            };
          }
        }
      }
      if (
        (!gameModelName || gameModelName === '不限') &&
        skillItem.selfSpreadPrice &&
        orderInfo.hasNewCoupon
      ) {
        mySettingPrice = skillItem.selfSpreadPrice;
      }
      if (budgetAmountRight < mySettingPrice) {
        // 是否需要降价抢单
        return {
          title: '您的價格超過訂單要求',
          description: `您的價格過高，是否為此次搶單降價？我們會為您把此次搶單的價格降到$${budgetAmountRight}/${salesUnitTranslate(
            salesUnit
          )}，不影響正常接單價格`,
          confirmButtonText: '降價搶單'
        };
      }
    },

    // 修改技能設置/降價確認確認彈窗
    confirmMarkDown({ title, description, confirmButtonText }) {
      return this.$confirm({
        content: description,
        title,
        confirmButtonText,
        cancelButtonText: '取消搶單'
      })
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },

    clockEnsure(time) {
      return this.$confirm({
        content: `設定喚醒時間為${time}，請確認是否同意搶單？`,
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      })
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },

    async checkOrderStatus(orderInfo, dialogShowText) {
      this.reducePrice = false;
      if (this.isLoading2) return;
      if (orderInfo.gameId === 38) {
        const jsonTime = JSON.parse(orderInfo.extraInfo);
        if (!(await this.clockEnsure(jsonTime.currentSelectTime))) return;
      }
      const checkResult = await this.skillSettingCheck(orderInfo);
      if (checkResult) {
        if (typeof checkResult === 'string') {
          this.$confirm({
            content: checkResult,
            confirmButtonText: '知道了',
            showCancelButton: false
          });
          return;
        }
        if (await this.confirmMarkDown(checkResult)) {
          const { skillId, name, gameModelId } = checkResult;
          if (skillId) {
            // 前往技能設置頁
            const { gameId, budgetAmountRight, salesUnit } = orderInfo;
            const price =
              budgetAmountRight === 999999 ? '' : budgetAmountRight + '';
            const infos = {
              gameModelId,
              skillId,
              price,
              salesUnit,
              name
            };
            sessionStorage.setItem('preSetPrice', JSON.stringify(infos));
            this.$router.push(
              `/player/skill/detail?skillId=${skillId}&gameId=${gameId}`
            );
            return;
          } else {
            this.reducePrice = true;
          }
        } else {
          return;
        }
      }
      this.isLoading2 = true;
      orderInfo[`${dialogShowText}Loading`] = true;
      this.orderUuid = orderInfo.uuid;
      this.$http
        .post('/match/quick/grab/player/apply/pre', {
          uuid: this.orderUuid,
          reducePrice: this.reducePrice
        })
        .then(async () => {
          this.isLoading2 = false;
          orderInfo[`${dialogShowText}Loading`] = false;
          if (orderInfo.type === 'PromiseWin') {
            const isagree = await this.promiseWinDialog();
            if (!isagree) return;
          }
          this[dialogShowText] = true;
          if (dialogShowText === 'orderByAuto') {
            this.grabOrderHandler(true, orderInfo.gameId);
          }
          if (dialogShowText === 'orderByAudioShow') {
            this.audioLoading = true;
            this.recorder = new Recorder();
            Recorder.getPermission().then(
              () => {
                this.audioLoading = false;
              },
              () => {
                this.$message.error({
                  message: '語音搶單需要開啟瀏覽器的麥克風權限'
                });
                setTimeout(() => {
                  this.orderByAudioShow = false;
                }, 2000);
              }
            );
          }
        })
        .catch(err => {
          this.isLoading2 = false;
          if (err.code === 723) {
            const id = orderInfo.gameId || 1;
            const message = {
              1: '若您達到菁英',
              6: '若您達到永恆傳說段位'
            };
            this.$confirm({
              content: `目前保贏單實行邀請制，${message[id]}，請準備好相關證明，聯繫客服小助手進行申請。`,
              confirmButtonText: '知道了',
              showCancelButton: false
            });
            return;
          }
          if (err.code === 722) {
            this.$confirm({
              content: '您的段位未到達“菁英”/“永恆傳說”，請認證後再來接單',
              confirmButtonText: '知道了',
              showCancelButton: false
            });
            return;
          }
          if (err.code !== 800) {
            this.$message.error({
              message: err.msg
            });
          }
        });
    },

    hasRepeatStr(ary) {
      const reg = new RegExp('[\u4e00-\u9fa5]+');
      return ary.some((str, index) => {
        if (index === 0 || index === ary.length - 1) return false;
        if (reg.test(str)) {
          return str === ary[index - 1] && str === ary[index + 1];
        }
      });
    },

    async grabOrderHandler(isAutoOrder, gameId) {
      let params = {};
      if (isAutoOrder) {
        params = {
          uuid: this.orderUuid,
          voiceTimeLength: null,
          voiceUrl: null,
          textContent: '',
          reducePrice: this.reducePrice,
          gameId: gameId
        };
      } else {
        if (this.isLoading2) return;
        const content = this.orderByTextContent;
        let voiceUrl = null;
        if (this.audioFile) {
          // 语音抢单
          this.isLoading2 = true;
          const dateNow = Date.now();
          const file = new File([this.audioFile], dateNow + '.wav', {
            type: 'audio/wav',
            lastModified: dateNow
          });
          const fd = new FormData();
          fd.append('file', file);
          const result = await uploadFileToS3(fd);
          if (result.code == 200) {
            voiceUrl = result.data;
          } else {
            this.$message.error({
              message: result.msg
            });
            this.isLoading2 = false;
            return;
          }
        } else if (content) {
          // 文字抢单
          if (content.length > 40 || this.illegalContent) return;
          let checkSimple = false;
          const ary1 = content.split('');
          if (this.hasRepeatStr(ary1)) {
            checkSimple = true;
          }
          if (!checkSimple) {
            const ary2 = [];
            ary1.forEach((str, index) => {
              if (index % 2 === 0) {
                ary2.push(content.substring(index, index + 2));
              }
            });
            if (this.hasRepeatStr(ary2)) {
              checkSimple = true;
            }
          }
          if (checkSimple) {
            this.$message.error({
              message: '重複文字太多，豐富的文字介紹可以增加被選中機會喔'
            });
            return;
          }
          this.isLoading2 = true;
        } else {
          return;
        }
        params = {
          uuid: this.orderUuid,
          voiceTimeLength: this.audioSeconds || null,
          voiceUrl,
          textContent: content || '',
          reducePrice: this.reducePrice
        };
      }

      this.$http
        .post('/match/quick/grab/player/apply', params)
        .then(() => {
          this.isLoading2 = false;
          this.orderByTextShow = false;
          this.orderByAudioShow = false;
          this.orderByTextContent = '';
          const list = this.listProcessing.filter(item => {
            return item.uuid === this.orderUuid;
          });
          if (!list.length) return;
          return this.$confirm({
            content: '恭喜加入搶單隊列！綜合評分UP！！',
            confirmButtonText: '前往等待頁',
            showCancelButton: false
          }).then(() => {
            this.viewOrder(list[0]);
          });
        })
        .catch(err => {
          this.isLoading2 = false;
          this.orderByTextShow = false;
          this.orderByAudioShow = false;
          this.$message.error({
            message: err.msg
          });
        });
    },

    audioClick() {
      const { audioStatus, audioLoading, isLoading2 } = this;
      if (audioLoading || isLoading2) return;
      if (audioStatus === 0) {
        // 开始录音
        if (!this.recorder) {
          this.audioLoading = true;
          this.recorder = new Recorder();
        }
        this.recorder.start().then(() => {
          this.audioStatus = 1;
          this.audioLoading = false;
          this.audioSeconds = 0;
          this.interval = setInterval(() => {
            this.audioSeconds++;
            if (this.audioSeconds === 15) {
              this.audioStop();
            }
          }, 1000);
          this.recorder.onplay = () => {
            this.audioStatus = 3;
            this.audioPlayed = 0;
            this.interval = setInterval(() => {
              this.audioPlayed++;
            }, 1000);
          };
          this.recorder.onresumeplay = () => {
            this.audioStatus = 3;
            this.interval = setInterval(() => {
              this.audioPlayed++;
            }, 1000);
          };
          this.recorder.onpauseplay = () => {
            this.audioStatus = 4;
            clearInterval(this.interval);
          };
          this.recorder.onplayend = () => {
            this.audioStatus = 2;
            clearInterval(this.interval);
            this.interval = null;
            this.audioPlayed = this.audioSeconds;
          };
        });
      } else if (audioStatus === 1) {
        // 结束录音
        if (this.audioSeconds < 3) return;
        this.audioStop();
      } else if (audioStatus === 2) {
        // 開始播放录音
        this.recorder.play();
      } else if (audioStatus === 4) {
        // 继续播放
        this.recorder.resumePlay();
      } else if (audioStatus === 3) {
        // 暂停
        this.recorder.pausePlay();
      }
    },
    audioStop() {
      if (!this.recorder) return;
      // this.recorder.stop()
      this.audioFile = this.recorder.getWAVBlob();
      this.audioStatus = 2;
      clearInterval(this.interval);
      this.interval = null;
      this.audioSeconds = Math.ceil(this.recorder.duration);
    },
    audioDelete() {
      this.audioStatus = 0;
      this.recorder.destroy().then(() => {
        this.recorder = null;
        clearInterval(this.interval);
        this.interval = null;
        this.audioSeconds = 0;
        this.audioPlayed = -1;
        this.audioFile = null;
      });
    },
    switchUnits() {
      if (!this.allowChangeUnit) return;
      const { salesUnit } = this.currentSelectedSkill;
      this.$set(
        this.currentSelectedSkill,
        'salesUnit',
        salesUnit === 'Game' ? 'Hour' : 'Game'
      );
    },
    downloadApp() {
      this.$util.jumpAppStore();
    },
    formatCurrency(ev) {
      let input = ev.target.value;
      // 限制输入只能包含数字和幣字
      const regex = /^[0-9]+(幣)?$/;
      input = input.replace(/0*/, '');
      if (regex.test(input)) {
        // 如果输入只有数字，自动在后面加上幣字
        if (!input.includes('幣')) {
          this.redBagCount = Number(input);
          input += '幣';
        } else {
          this.redBagCount = input;
          this.redBagCount.slice(0, -1);
          this.redBagCount = Number(this.redBagCount);
        }
        // this.redBagCountErrorMessage =
        //   Number(value) < 10 ? '紅包金額需大於10' : '';
        this.redBagText = input;
        console.log(input);
      } else {
        this.redBagCount = 0;
        this.redBagText = '';
        console.log(input);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// body-common
.dialog-skill-inner {
  max-height: 400px;
  overflow: auto;
}
.page-body-new {
  display: flex;
  .title {
    @include flex(space-between);
    line-height: 24px;
    color: #333;
    &.disabled {
      opacity: 0.5;
    }
    .avatar {
      width: 24px;
      height: 24px;
    }
  }
  .card {
    position: relative;
    background-color: #ffffff;
    box-shadow: 0px 4px 14px rgba(17, 25, 38, 0.18);
    border-radius: 10px;
    overflow: hidden;
  }
  .section {
    &-left {
      .title {
        padding: 20px 15px 11px;
        font-size: 16px;
        .avatar {
          margin-right: 8px;
        }
      }
    }
    &-right {
      & > * {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .card:not(.first) {
        margin-top: 16px;
      }
      .ongoing {
        .card {
          cursor: pointer;
          transition: background 0.2s;
          &:active {
            background: linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.08),
                rgba(0, 0, 0, 0.08)
              ),
              #ffffff;
          }
          .order-footer {
            background: rgba(50, 61, 79, 0.12);
          }
        }
        .title {
          padding: 15px;
          font-size: 14px;
          border-bottom: 1px solid #eee;
          .avatar {
            margin-right: 5px;
          }
        }
        .order-body {
          position: relative;
          @include flex(flex-start, flex-start);
          padding: 22px 15px 24px;
        }
        .game-logo {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          line-height: 48px;
          margin-right: 10px;
          overflow: hidden;
        }

        .main-info {
          flex-grow: 1;
          overflow: hidden;
          h3 {
            @include ellipsis(1);
            font-size: 17px;
            font-weight: 500;
            line-height: 21px;
            color: #333;
            margin-bottom: 12px;

            p + p {
              margin-top: 4px;
            }

            .main-name {
              margin-right: 6px;
            }
            .order-type-text {
              color: #f06950;
            }
          }

          .order-desc {
            color: #666;
            font-size: 14px;
            line-height: 20px;
          }

          .remark {
            @include ellipsis(2);
          }
        }

        .buttons {
          display: flex;
          align-items: center;
          // flex-shrink: 0;
          // width: 150px;
          // margin-left: 35px;
          font-weight: 400;
          padding: 0 140px 15px 73px;
          button {
            width: 100%;
            height: 40px;
            line-height: 40px;
            & + button {
              margin-left: 12px;
            }
            &.default {
              background-color: #f0f0f0;
              color: #8c8c8c;
            }
            &.disabled {
              cursor: not-allowed;
            }
          }
        }

        .order-footer {
          @include flex(space-between);
          height: 34px;
          padding: 0 12px 0 15px;
          font-size: 12px;
          line-height: 17px;
          color: #323d4f;
          background: rgba(50, 61, 79, 0.12);
        }
      }
      .complete {
        .card {
          overflow: hidden;
          border-radius: 10px;
          background-color: rgba(255, 255, 255, 0.1);
        }
        .title {
          padding: 17px 15px 19px;
          font-size: 16px;
          color: #fff;
          justify-content: space-between;
          line-height: 24px;
          .infos {
            display: flex;
          }
          .avatar {
            background: none;
            margin-right: 8px;
            &:first-child {
              margin-right: 6px;
            }
          }
          .time {
            color: #8e9aaf;
            font-size: 14px;
          }
        }
        .order-body {
          padding: 0 15px 20px;
          color: #8e9aaf;
          font-size: 14px;
          line-height: 20px;
        }
        .bottom {
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          color: #ffffff;
          opacity: 0.5;
          margin-top: 24px;
        }
      }
    }
    &-title {
      color: #ffffff;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      opacity: 0.8;
      margin-bottom: 20px;
    }
  }
  .form {
    padding: 0 15px 20px;
    .item {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      min-height: 50px;
      padding: 14px 12px;
      margin-top: 9px;
      background: #f2f2f2;
      border-radius: 8px;
      color: #333;
      font-size: 16px;
      line-height: 22px;
      &:not(.remark) {
        @include ellipsis(1);
      }
      &.count {
        padding: 10px 6px;
      }
    }
    .items {
      display: flex;
      & > * {
        flex-grow: 1;
        flex-shrink: 0;
        width: 40%;
        margin: 9px 0 0 9px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .input-number {
      width: 100%;
      height: 30px;
    }
    .remark {
      .text {
        height: 66px;
        @include ellipsis(3);
        &.empty::after {
          content: '備註 (選填)：例如“聲音好聽”等';
          color: #999;
        }
      }
    }
    .red-beg-input-box {
      padding: 0 !important;
      padding-left: 6px !important;
      display: flex;
      align-items: center;

      /deep/ .el-input {
        &.no-value {
          .el-input__prefix {
            opacity: 0.15;
          }
        }
        display: flex;
        align-items: center;
        .el-input__inner {
          background-color: inherit;
          border: none;
        }
        .el-input__prefix {
          display: flex;
          align-items: center;
        }
      }
    }
    .error {
      padding-top: 4px;
      font-size: 12px;
      color: red;
    }
    &.disabled {
      opacity: 0.5;
      // .submit {
      //   background: #ff7ab5;
      //   font-size: 15px;
      // }
    }
    .submit {
      position: relative;
      width: 100%;
      height: 50px;
      margin: 25px 0 0;
      border-radius: 50px;
      font-size: 17px;
      // &.disabled {
      //   background: #ff7ab5;
      //   cursor: not-allowed;
      // }
      // b端功能
      // &.btn-player {

      // }
      .coupon {
        position: absolute;
        overflow: hidden;
        left: 50%;
        top: -8px;
        height: 30px;
        margin-left: 35px;
        .coupon-inner {
          position: relative;
          height: 22px;
          line-height: 22px;
          padding: 0 6px;
          background-color: #fdbe86;
          border-radius: 2px;
          color: #643308;
          font-size: 12px;
          font-weight: 500;
          &::after {
            content: '';
            @include triangle(9px, #fdbe86);
            position: absolute;
            transform: rotate(135deg);
            left: -8px;
            bottom: -4px;
          }
        }
      }
    }
  }
}

// 通用按钮样式
.button-wrap {
  padding: 30px 0;
}
.btn-custom {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  border-radius: 50px;
  @include button-yellow;
}
.coupons-checked {
  margin-bottom: 12px;
}
.coupons-checked-price {
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 10px;
  background: #f2f2f2;
  color: #333333;
}
@media screen and(min-width: 600px) {
  // layout-web
  .quick-order-create {
    position: relative;
    min-height: 1039px;
    padding-bottom: 104px;
    .quick-order-bg {
      position: absolute;
      z-index: 0;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      width: 200%;
      height: 100%;
      background: url('~@/assets/image/background/game-cells.png') repeat-x left
        top;
      background-size: auto 384px;
    }
    .quick-order-inner {
      position: relative;
      z-index: 1;
      width: 980px;
      margin: auto;
    }
    .page-title {
      padding: 40px 0 50px;
      color: white;
      h3 {
        font-size: 30px;
        line-height: 42px;
        font-weight: 500;
      }
      p {
        font-size: 18px;
        line-height: 25px;
        margin-top: 8px;
        opacity: 0.5;
      }
    }
  }

  // body-web
  .page-body-new {
    .mobile {
      display: none;
    }
    .form {
      .item {
        &:not(.readonly) {
          cursor: pointer;
          transition: 'background' 0.2s;
          &:hover {
            background: #dfdfdf;
          }
        }
        // &.disabled {
        //   cursor: not-allowed;
        //   background: #f2f2f2;
        // }
      }
      &.disabled {
        .item:not(.readonly):hover,
        /deep/ .el-input__inner:hover {
          cursor: not-allowed;
          background: #f2f2f2;
        }
        .submit {
          cursor: not-allowed;
        }
      }
    }
    .section {
      &-left {
        flex-shrink: 0;
        width: 339px;
      }
      &-right {
        flex-grow: 1;
        margin-left: 30px;
      }
    }
    .order-info-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // > span {
      //   display: flex;
      //   align-items: center;
      //   > span {
      //     display: flex;
      //     align-items: center;
      //   }
      // }
      /deep/ .el-popover__reference-wrapper {
        display: flex;
        align-items: center;
      }
      .invited-web {
        width: 30px;
        height: auto;
      }
    }
    .section-title {
      font-size: 22px;
      line-height: 30px;
      font-weight: 500;
      margin-bottom: 28px;
    }
  }

  // 自定义dialog-web
  /deep/ {
    .dialog-quick-order {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      border-radius: 15.0113px;
      box-shadow: 0px 5.00376px 7.50564px rgba(0, 0, 0, 0.1);
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        overflow: hidden;
        padding: 0 18px;
      }
    }
  }

  // 自定义select-价格选择
  .quickorder-select {
    width: 290px;
    &.price {
      width: 214px;
    }
    /deep/ {
      .el-input__inner {
        height: 50px;
        background: #f2f2f2;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        color: #333;
        transition: background 0.2s;
        &:active,
        &:hover {
          background: #dfdfdf;
        }
      }
      .el-input__suffix {
        display: none;
      }
    }
    &-options {
      .el-select-dropdown__item {
        height: 58px;
        padding: 0 18px;

        &.selected {
          .check-icon {
            display: block;
          }
        }

        .custom-option {
          @include flex(space-between);
          height: 58px;
          color: #333;
          font-weight: normal;
        }

        span {
          font-size: 16px;
          line-height: 23px;
        }

        .check-icon {
          font-size: 18px;
          color: $color-yellow;
          display: none;
        }
      }
    }
  }
}

@media screen and(max-width: 599px) {
  // layout-h5
  .quick-order-create {
    min-height: 880px;
    padding-bottom: 100px;
    .quick-order-inner {
      width: 100%;
      margin: auto;
    }
    .page-title {
      width: 90vw;
      margin: auto;
      padding: 30px 0;
      color: white;
      h3 {
        font-size: 24px;
        line-height: 34px;
        font-weight: 500;
      }
      p {
        font-size: 14px;
        line-height: 20px;
        margin-top: 5px;
        opacity: 0.5;
      }
    }
  }

  .mobile-card {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
    border-radius: 10px;
    .text {
      @include flex(center, center, column);
      height: 100%;
      padding: 0 50px 50px;
      color: $color-gray-1;
      text-align: center;
      p {
        margin-top: 20px;
        line-height: 22px;
      }
    }
    button {
      position: absolute;
      left: 15px;
      bottom: 20px;
      width: calc(100% - 30px);
      height: 50px;
      border-radius: 50px;
      font-size: 17px;
      @include button-yellow;
    }
  }

  // body-h5
  .page-body-new {
    flex-wrap: wrap;
    .pc {
      display: none;
    }
    .form .item {
      &:not(.readonly) {
        transition: 'background' 0.2s;
        &:active {
          background: #dfdfdf;
        }
      }
    }
    .section {
      &-left {
        width: 90vw;
        margin: 0 auto;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        .section-title {
          display: none;
        }
      }
      &-right {
        width: 90vw;
        margin: 50px auto 0;
      }
    }
    .section-right {
      .ongoing {
        .order-body.allow-order {
          padding-bottom: 80px;
        }
        .main-info {
          h3 {
            margin-bottom: 8px;
          }
        }
        .buttons {
          flex-shrink: 0;
          width: 75px;
          margin-left: 10px;
          font-weight: 400;
          button {
            width: 100%;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            & + button {
              margin-top: 15px;
            }
          }
        }
      }
    }
    .section-title {
      font-size: 18px;
      line-height: 25px;
      font-weight: 500;
    }
  }

  // 自定义dialog-h5
  /deep/ {
    .dialog-quick-order {
      box-sizing: border-box;
      overflow: hidden;
      width: 100% !important;
      max-height: 70vh;
      position: fixed;
      left: 0;
      bottom: 0;
      margin-top: 0 !important;
      margin-bottom: 0;
      border-radius: 0;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      box-shadow: 0px 5.00376px 7.50564px rgba(0, 0, 0, 0.1);
      padding: 0 5vw;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        overflow: hidden;
        padding: 0;
      }
    }
  }

  // 技能选择外层-h5
  .dialog-skill {
    &-wrap {
      display: flex;
      flex-direction: column;
      max-height: 70vh;
    }
    &-inner {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 14px 0 16px;
      & + .btn-custom {
        margin-top: 14px;
      }
      & > div {
        margin-top: -14px;
      }
      &::after {
        content: '';
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 16px;
        background-color: #fff;
      }
    }
  }

  // 价格选择外层-h5
  .dialog-prize {
    .title {
      @include flex(space-between);
      color: #333;
      padding: 20px 19px;
      border-bottom: 1px solid #ddd;
      button {
        font-size: 14px;
      }
      .confirm {
        color: #fa006e;
      }
      p {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .scroller {
      height: 247px;
      margin: auto;
      background: white;
      .selected {
        color: white;
        background: #fa006e;
        border: none;
      }
      /deep/ .picker-slot {
        width: 100% !important;
      }
    }
  }
}
.promise-win {
  font-size: 14px;
  color: #f06950;
}
.title-left {
  position: relative;
  display: flex;
  justify-content: flex-start;
}

.order-text-wrap {
  .title {
    @include flex(space-between);
    margin-top: 30px;
    color: #333;
    font-size: 17px;
    font-weight: 500;
    line-height: 24px;
    .close {
      @include flex;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }
  .desc {
    margin-top: 6px;
    color: #a9a9a9;
    font-size: 14px;
    line-height: 20px;
  }
  .textarea {
    position: relative;
    margin-top: 17px;
    textarea {
      display: block;
      width: 100%;
      height: 100%;
      padding: 14px;
      line-height: 20px;
      color: #333;
      font-size: 14px;
      background: #f6f6f7;
      border: 1px solid #e2e3e6;
      border-radius: 10px;
      resize: none;
    }
    .letter-num {
      position: absolute;
      z-index: 1;
      right: 12px;
      bottom: 8px;
      color: #a9a9a9;
      font-size: 12px;
      .light {
        color: $color-red;
      }
    }
    .gap {
      position: absolute;
      z-index: 2;
      left: 0;
      top: 0;
      widows: 100%;
      height: 100%;
      cursor: not-allowed;
    }
  }
  .tip {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}
.order-audio-wrap {
  text-align: center;
  .close {
    @include flex;
    margin-top: 20px;
    margin-left: 309px;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
  .title {
    margin-top: 12px;
    color: #333;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
  }
  .desc {
    margin-top: 8px;
    p {
      color: #666;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .audio-panel {
    @include flex;
    margin: 20px 0 26px;
    width: 100%;
    height: 90px;
    .circle {
      flex-shrink: 0;
      position: relative;
      width: 88px;
      height: 88px;
      .button {
        @include flex;
        position: absolute;
        left: 4px;
        top: 4px;
        width: 80px;
        height: 80px;
        border-radius: 100%;
        background: linear-gradient(126deg, #ff4417 2.04%, #fb006e 60.91%);
        cursor: pointer;
      }
    }
    .time,
    .delete {
      flex-grow: 1;
      width: 50%;
      color: #000;
      font-size: 14px;
      font-weight: 500;
      > div {
        cursor: pointer;
        width: 24px;
        margin: 0 auto;
      }
    }
  }
}
.new-coupon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  padding: 0 16px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  font-size: 16px;
  color: #eab38f;
  /deep/ .time-item {
    margin: 0;
  }
}
.coupon-countdown {
  display: flex;
}
.userlevel-tag {
  position: absolute;
  height: 16px;
  left: -6px;
  bottom: -10px;
  z-index: 1;
}
</style>
